<div class="timeline_items single">
  <div class="not_found" *ngIf="singleTimeline.bricks.length==0">No sessions or activities</div>
  <ng-container *ngFor="let session of singleTimeline.bricks; first as first; last as last; index as index; trackBy: trackByBrick">
    <timeline-item
      *ngIf="{ briefSession: brief && session.performerIds?.includes(performer?.id), next: singleTimeline.bricks[index+1], isActivity: session.type === 'activity', start: !!first ? session.start || session.time : { session: session, priorSession: singleTimeline.bricks[index-1] } | timelineStart } as v"
      [start]="v.start" 
      [hideDot]="!v.start && !last"
      [end]="session.end"
      [brief]="brief"
      [first]="first"
      [last]="last"
      [link]="link"
      [stagingNotes]="session.notes"
      [files]="session.files"
      [standalone]="session.isStandalone"
      [title]="session.title"
      [condensedPerformers]="condensedPerformers"
      [description]="session.description"
      [startingCollapseState]="collapseByDefault ? 'collapse' : 'expand'"
      [labelMap]="v.isActivity ? labelMaps.activity_labels : labelMaps.session_labels"
      [labelMaps]="brief || v.isActivity ? null : labelMaps"
      [labelIds]="(detailedMode || brief) ? session.labels : null"
      [performers]="(brief || detailedMode) && !v.isActivity ? performers : null"
      [performerIds]="(brief || detailedMode) && !v.isActivity ? session.performerIds : null"
      [sponsors]="(brief || detailedMode) && !v.isActivity ? sponsors : null"
      [sponsorIds]="(brief || detailedMode) && !v.isActivity ? session.sponsorIds : null"
      [sponsorTypes]="sponsorTypes"
      [hidePerformersHeading]="hidePerformersHeading"
      [publicLinks]="session.publicLinks"
      [programLine]="programLines[session.id]"
      [type]="session.type"
      [activityIncomplete]="v.isActivity && showActivityStatus && !session.completed"
      [activityComplete]="showActivityStatus && session.completed"
      [publicView]="publicView"
      [performer]="performer"
      [presentationNotes]="session.presentationNotes"
      [presentationAssets]="session.presentationAssets"
      [otherAssets]="session.otherAssets"
      [tagData]="tagMap[session.id]"
      [performerRoleIds]="session['performerRoles']"
      [performerRoles]="performerRoles"
      [stagingRequests]="session.stagingRequests"
      (selectProgram)="openProgramEmitter.emit({event: $event, scheduleId: session.program_scheduleId})"
      (selectItem)="emitBrickDetail.emit(session)"
    >
  </timeline-item>
  </ng-container>
  
</div>